import {defineStore} from "pinia";
import {ref} from "vue";
import myPageApi from "@/services/api/myPageApi";
import {isEmpty} from "lodash-es";

const MY_INIT_DATA = () => {
    return {
        //나의 자녀관리
        childNm: "",
        //나의 위임관리
        delegateObj: {},
        //나의 청구이력 청구번호
        acrndNo: '',
        //인증수단 관리
        loginMethod: {},
        //나의 정보
        myInfo: {},
        //변경된 이름
        changeNm: '',
        //페이징
        limit : 10
    }
}

export const useMyPageStore = defineStore(
    "useMyPageStore",
    () => {
        const myPage = ref({});
        const init = () => {
            Object.assign(myPage.value, MY_INIT_DATA());
        }

        const setItem = (value) => {
            for (const key in value) {
                myPage.value[key] = value[key];
            }
        }

        //모든 인증수단 목록 조회
        const fnLoginMethod = async () => {
            const obj = {
                officialAuth: false,
                kakaoAuth: false,
                naverAuth: false,
                googleAuth: false,
            }

            /*
            result.loginMethodList : 등록된 인증수단 리스트
            result.loginSnsRdoList : 연결된 소셜로그인 리스트
            result.loginCertRdoList : 연결된 공인/금융인증서 리스트
            result.loginIdPwd : 아이디 리스트 (단일)
            result.loginQuickRdoList : 연결된 퀵 로그인 (생체/간편비밀번호) 리스트
            */
            let data = await myPageApi.getLoginMethod();

            //공동, 금융 인증서 로그인 목록
            let certRdoList = data.loginCertRdoList;

            //sns 로그인 목록
            let snsRdoList = data.loginSnsRdoList;

            if (!isEmpty(certRdoList)) {
                certRdoList.forEach(item => {
                    if (item.crtfiKind === 'officialAuth') {
                        obj.officialAuth = true
                    }
                });
            }
            if (!isEmpty(snsRdoList)) {
                snsRdoList.forEach(item => {
                    if (item.socialPlatform === 'kakao') {
                        obj.kakaoAuth = true
                    }
                    if (item.socialPlatform === 'naver') {
                        obj.naverAuth = true
                    }
                    if (item.socialPlatform === 'google') {
                        obj.googleAuth = true
                    }
                });
            }
            myPage.value.loginMethod = obj
        }

        return {myPage, init, setItem, fnLoginMethod};
    },
    {
        persist: {
            storage: sessionStorage
        }
    }
)